/**
 * SeatAssignmentPage.tsx
 * 좌석 배정 페이지
 *
 * 오너가 학생을 검색하고 좌석에 배정/해제하는 페이지
 */

import React from 'react';
import { useAuthStore } from '../../domains/auth/stores/AuthStore';
import StudentAssignmentPanel from '../../domains/owner/components/seat-layout/StudentAssignmentPanel';

const SeatAssignmentPage: React.FC = () => {
  const { user } = useAuthStore();

  if (!user?.organization_id) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <p className="text-gray-600">조직 정보를 불러오는 중...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">좌석 배정</h1>
            <p className="text-sm text-gray-600 mt-1">
              학생을 검색하고 좌석을 배정하거나 해제할 수 있습니다
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-hidden p-6">
        <StudentAssignmentPanel organizationId={user.organization_id} />
      </div>
    </div>
  );
};

export default SeatAssignmentPage;
